const reports = {
  users: {
    table: {
      users: 'Usuario',
      login: 'Inicio de sesión',
      accessLevel: 'Nivel de acceso',
      activationDate: 'Fecha de activación',
      lastLogin: 'Último inicio de sesión',
      status: 'Estado',
    },
    search: 'Usuario / Inicio de sesión',
    refreshButton: 'Buscar',
    resetButton: 'Reiniciar',
    dateFilter: {
      activation: 'Fecha de activación',
      lastLogin: 'Último inicio de sesión',
      notLogged: 'No ha iniciado sesión en los últimos',
    },
    statusFilter: {
      all: 'Todos los estados',
      active: 'Activo',
      inactive: 'Inactivo',
    },
    allAccesslevel: 'Todos los niveles de acceso',
  },
  cards: {
    table: {
      card: 'Credencial',
      format: 'Formato',
      username: 'Nombre de usuario',
      activationDate: 'Fecha de activación',
      lastUsed: 'Último uso',
      status: 'Estado',
      assigned: 'Asignado',
      stolen: 'Robado',
      lost: 'Perdido',
      lockdown: 'Bloqueo',
      usedForAccess: 'Usado para acceso',
    },
    cardSearch: 'Credencial',
    usernameSearch: 'Usuario',
    cardStatusRadio: 'Estatus de credencial',
    cardOptionsRadio: 'Opciones de credencial',
    allFormats: 'Todos los formatos',
    cardStatusFilter: {
      all: 'Todo',
      active: 'Activado',
      inactive: 'Inactivado',
    },
    cardAssignedFilter: {
      all: 'Todo',
      yes: 'Si',
      no: 'No',
    },
    dateFilter: {
      activation: 'Fecha de activación',
      lastUsed: 'Último uso',
      notUsed: 'No utilizado en',
    },
  },
};

export default reports;
